import React, {useCallback, useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {Navigate, Route, Routes, useParams} from 'react-router-dom';


import {
    getCriteria,
    selectSearchCriteria,
} from 'src/components/criteria-strip/services/criteria-strip-slice';
import {SEARCH_RESULT_TABS} from 'src/constants';
import {PageNotFound} from 'src/modules/error-page';
import {selectManagedAccountIds, selectUserShortInfo} from 'src/modules/main/services/user-info-slice';
import {AssignedAccounts} from 'src/modules/profile/user/tabs/assigned-accounts';

import {FormSection} from '@pb/kit-component-form-section';
import {Group} from '@pb/kit-component-group';

import {AccountSearchCriteria} from './components/account-search/account-search-criteria';
import {RecentlyViewedSection} from './components/recently-viewed/recently-viewed-section';
import {UserSearchCriteria} from './components/user-search/user-search-criteria';

import {
    searchCriteriaCriteriaContainer,
    searchCriteriaMyAccountInfoContainer,
} from './search-criteria.module.styl';

export const SearchCriteria = () => {
    const dispatch = useDispatch();

    const {searchId = ''} = useParams<{searchId?: string}>();
    const criteria = useSelector(selectSearchCriteria);
    const userSortInfo = useSelector(selectUserShortInfo);
    const managedAccountIds = useSelector(selectManagedAccountIds);

    useEffect(() => {
        dispatch(getCriteria(searchId));
    }, [searchId, dispatch]);

    const getMyAccountsInfo = useCallback((info: React.ReactNode) => (
        <header className={searchCriteriaMyAccountInfoContainer}>
            {info}
        </header>
    ), []);

    return criteria ? (
        <div>
            <section className={searchCriteriaCriteriaContainer}>
                <Group justify="space-between" alignItems="start">
                    <Routes>
                        <Route
                            path={`/${SEARCH_RESULT_TABS.ACCOUNTS}`}
                            element={<AccountSearchCriteria searchId={searchId}/>}
                        />
                        <Route
                            path={`/${SEARCH_RESULT_TABS.USERS}`}
                            element={<UserSearchCriteria searchId={searchId}/>}
                        />
                        <Route
                            path="*"
                            element={<Navigate to={`/search-criteria/${searchId}/${SEARCH_RESULT_TABS.ACCOUNTS}`}/>}
                        />
                    </Routes>
                    <RecentlyViewedSection/>
                </Group>
            </section>
            {managedAccountIds?.length ? (
                <FormSection headline="My Accounts" info={getMyAccountsInfo}>
                    {userSortInfo ? (
                        <AssignedAccounts place="Only My Accounts" user={userSortInfo}/>
                    ) : null}
                </FormSection>
            ) : null}
        </div>
    ) : <PageNotFound/>;
};
